import React from "react";

class TableSmallBody extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            staredHand: this.props.hand.staredHand,
        }
    }

    toggleStaredHand = () => {
        this.setState({ staredHand: !this.state.staredHand }, () => {
            this.props.setStarFlagOfHnad(this.props.hand, this.state.staredHand)
        });
    }

    render() {
        let profit = this.props.hand.playerStats.endStack-this.props.hand.playerStats.startStack
        let { isSeeMore = true } = this.props,
            profityStyle = profit >= 0 ? { color: '#6DB92C' } : { color: '#D32121' }
        return (
            <tr className="mygameluck-tr" >
                <td className={` ${isSeeMore ? 'luckModalTd' : ' holeCardMob'}`}>
                    {this.props.hand[`holeCardUrl`].map((cardUrl, index) => {
                        return cardUrl === ''
                            ? <div key={index} className="luckHandCards" ></div>
                            : <img
                                key={index}
                                className="luckHandCardsWithCard"
                                src={`https://mygame-dev.mypartypokerlive.com${cardUrl}`}
                                role="presentation"
                            />
                    })}
                </td>
                <td className={`${isSeeMore ? 'luckModalTd' : 'mygameluck-tr profitMob'}`}  style={profityStyle}>{profit >= 0 ? '+' : '-'}{this.props.hand.gameType === 'cash' && '$'}{Math.abs(profit).toFixed(2).toString()}{this.props.hand.gameType === 'tournament' && ' BB'}</td>
                <td className={`${isSeeMore ? 'luckEditNote luckModalTd' : 'mygameluck-tr luckEditNote'}`} style={{ position: "relative" }}>
                    {(this.props.hand.notes && this.props.hand.notes.length > 0) ? <span className="notecount" style={{ top: isSeeMore ? "45px" : "21px" }}>{this.props.hand.notes.length}</span> : null}
                    <i style={{ fontSize: "23px", cursor: "pointer" }}
                        data-toggle="modal"
                        data-target="#EditNoteModal"
                        onClick={(e) => {
                            e.preventDefault()
                            this.props.openNotes(this.props.hand)
                        }}
                        className={`staredHandColor edit_notePad ${(this.props.hand.notes && this.props.hand.notes.length > 0)
                            ? "fa fa-pencil-square padding_pencil_square"
                            : "fa fa-pencil-square-o staredHandColorUnstar"}`}>
                    </i>
                </td>
                <td className={`${isSeeMore ? 'luckModalTd luckStar' : 'mygameluck-tr luckStar'}`}><i onClick={this.toggleStaredHand} className={"staredHandColor " + (this.state.staredHand ? "fa fa-star" : "fa fa-star-o staredHandColorUnstar") + " MyHands_desktopstarPosition "}></i></td>
                <td className={`${isSeeMore ? 'luckReplay luckModalTd' : 'mygameluck-tr luckReplay'}`}><i style={{ fontSize: "30px", cursor: "pointer" }} className="hoverScale fa fa-play-circle staredHandColor" data-e2e="replayer" onClick={() => { this.props.handReplayerOpen(this.props.hand) }}></i></td>
            </tr>
        )
    }
}

export default TableSmallBody;


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/TableSmallBody.js
 **/